import { useEffect, useState } from 'react';
import { map } from 'lodash';
import { AiPlan } from '../../../types/plan.types';
import PlansService from '../../../services/plans.service';
import { getLocateDate } from '../../../utils/format-date-time.utils';
import Button from '../../common/Button';
import { useNavigate } from 'react-router-dom';

const Plans = () => {
  const [plans, setPlans] = useState<AiPlan[]>([]);
  const navigate = useNavigate();

  const getPlans = async () => {
    try {
      const response = await PlansService.getPlans();
      if (response.data.data && response.data.data.plans) {
        setPlans(response.data.data.plans);
      } else {
        console.log('Error: ', response.data.message);
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getPlans();
  }, []);

  return (
    <div className="overflow-y-auto w-full p-5">
      <div className="flex justify-between items-center mb-8">
        <h3 className="font-normal text-[40px]">Subscription Plans</h3>
        <div>
          <Button
            classes="bg-[#333] text-white"
            onClick={() => navigate('/create-plan')}
          >
            Create Plan
          </Button>
        </div>
      </div>
      <div className="overflow-x-auto p-5 rounded-2xl shadow-[0_0_8px_#cbcbcb]">
        <table className="text-[14px] bg-white min-w-full">
          <thead className="text-left">
            <tr className="text-[#616161]">
              <th className="p-3 min-w-[100px]">Name</th>
              <th className="p-3 min-w-[100px]">Interval</th>
              <th className="p-3 min-w-[100px]">Price</th>
              <th className="p-3 min-w-[100px]">Description</th>
              <th className="p-3 min-w-[100px]">Created At</th>
              <th className="p-3 min-w-[100px]"></th>
            </tr>
          </thead>
          <tbody className="text-[#333] font-regular">
            {map(plans, (plan) => (
              <tr
                className="static rounded-lg border-b-8 border-white last:border-none"
                key={plan._id}
              >
                <td className="px-3 py-5 first:font-semibold bg-[#fcfcfc]">
                  {plan.name}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{plan.planInterval}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">{plan?.price ?? 0}</td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {plan?.description ?? '--'}
                </td>
                <td className="px-3 py-5 bg-[#fcfcfc]">
                  {plan?.createdAt && getLocateDate(plan?.createdAt)}
                </td>
                <td
                  className="px-3 py-5 bg-[#fcfcfc] cursor-pointer"
                  onClick={() => navigate(`/subscription-plans/${plan._id}`)}
                >
                  <span className="font-bold">View Details</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Plans;
